import { CSSObject } from "@emotion/react";
import { type ButtonStyleOverrides } from "@newsela/angelou";

export const cardActionsContainerCss: CSSObject = {
  display: "flex",
  alignItems: "center",
  position: "relative",
  justifyContent: "space-between",
  zIndex: 2,
  gap: 8,
  paddingTop: "16px",

  "div:nth-child(1)": {
    flexGrow: 2,
  },

  "div:nth-child(2)": {
    flexGrow: 1,
  },
};

export const addToAssignmentButtonCss: ButtonStyleOverrides<CSSObject> = {
  root: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    padding: "15px 4px 15px 4px",
  },
};

export const linkCss = {
  root: {
    width: "100%",
    padding: "15px 8px 15px 8px",

    "> div": {
      display: "flex",
      justifyContent: "center",
    },
  },
};

export const contentSettingsModeCss = {
  zIndex: 1,
  marginLeft: 0,
  width: "100%",
  padding: "12px 0",
};
